import { render, staticRenderFns } from "./informasi-skripsi.vue?vue&type=template&id=60a5d81d"
import script from "./informasi-skripsi.vue?vue&type=script&lang=js"
export * from "./informasi-skripsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports